export default __webpack_public_path__ + "eaf4ca19608f21c06ad12ca63da10ec5.png";